export const FIRST_STEP_INDEX = 0;